import { ResolveFn } from '@angular/router';

import { forkJoin, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { themeResolver } from '@ledgerly/shared/theming';

export const appResolver: ResolveFn<unknown[]> = (route, state) => {
  const observables = [of(themeResolver(route, state))];

  return forkJoin(observables).pipe(
    switchMap(([user]) => {
      return of([user]);
    })
  );
};
